import { NotificationMessage } from '../common';
import { RetailKADMessageResponse } from '../services/Market.service';

export type UpsellState = {
  isModalOpen: boolean;
  market?: string;
  notification?: NotificationMessage;
  activeSlideIndex?: number;
  pageName?: string;
  bannerNumber?: number;
  singleSlide?: () => React.ReactElement | null;
  retailKADUpsellMessage?: RetailKADMessageResponse | null;
};
export const initialState: UpsellState = {
  isModalOpen: false,
};
